module.exports = __webpack_public_path__ + "media/images/backgrounds/blog-header-image-glass-2-f5c20ce0bae6f76e4393ab196340db05.png";